import { TeamMember } from './types'

const engagedPreview = (names: string[]): TeamMember['engagedWith'] =>
  names.map((name, index) => ({
    id: `engaged-${name.toLowerCase().replace(/\s+/g, '-')}-${index}`,
    name,
  }))

/** Temporary AE seed data until the members API is wired. */
export const DUMMY_TEAM_MEMBERS: TeamMember[] = [
  {
    id: 'ae-floyd-ironwel',
    name: 'Floyd Ironwel',
    role: 'GenAI Growth Manager',
    location: 'Los Angeles',
    engagedWith: engagedPreview(['Alex Kim', 'Jordan Lee', 'Sam Patel']),
    engagedWithCount: 14,
  },
  {
    id: 'ae-darrell-cooper',
    name: 'Darrell Cooper',
    role: 'GenAI Growth Manager',
    location: 'Los Angeles',
    engagedWith: engagedPreview(['Casey Ng', 'Riley Chen', 'Morgan Diaz']),
    engagedWithCount: 14,
  },
  {
    id: 'ae-jacob-jones',
    name: 'Jacob Jones',
    role: 'GenAI Growth Manager',
    location: 'Los Angeles',
    engagedWith: engagedPreview(['Taylor Brooks', 'Jamie Fox', 'Quinn Reed']),
    engagedWithCount: 14,
  },
  {
    id: 'ae-leslie-alexander',
    name: 'Leslie Alexander',
    role: 'GenAI Growth Manager',
    location: 'Los Angeles',
    engagedWith: engagedPreview(['Avery Cole', 'Drew Hayes', 'Blake West']),
    engagedWithCount: 14,
  },
  {
    id: 'ae-esther-howard',
    name: 'Esther Howard',
    role: 'Enterprise AE',
    location: 'New York',
    engagedWith: engagedPreview(['Cameron Ortiz', 'Reese Park', 'Harper Diaz']),
    engagedWithCount: 9,
  },
  {
    id: 'ae-jane-cooper',
    name: 'Jane Cooper',
    role: 'Strategic AE',
    location: 'Seattle',
    engagedWith: engagedPreview(['Noah Grant', 'Ellie Shaw', 'Owen Price']),
    engagedWithCount: 11,
  },
  {
    id: 'ae-robert-fox',
    name: 'Robert Fox',
    role: 'Cloud Specialist',
    location: 'Austin',
    engagedWith: engagedPreview(['Liam Scott', 'Mia Torres', 'Ethan Bell']),
    engagedWithCount: 7,
  },
  {
    id: 'ae-brooklyn-simmons',
    name: 'Brooklyn Simmons',
    role: 'Growth Manager',
    location: 'Chicago',
    engagedWith: engagedPreview(['Sofia Lane', 'Lucas Hart', 'Zoe Miles']),
    engagedWithCount: 12,
  },
  {
    id: 'ae-wade-warren',
    name: 'Wade Warren',
    role: 'Partner AE',
    location: 'Boston',
    engagedWith: engagedPreview(['Nina Cole', 'Owen Blake', 'Ivy Stone']),
    engagedWithCount: 8,
  },
  {
    id: 'ae-cameron-williamson',
    name: 'Cameron Williamson',
    role: 'GenAI Growth Manager',
    location: 'San Francisco',
    engagedWith: engagedPreview(['Leo Dunn', 'Aria Wells', 'Kai Brooks']),
    engagedWithCount: 16,
  },
]

export const DUMMY_SUGGESTED_MEMBER_IDS = DUMMY_TEAM_MEMBERS.slice(0, 4).map(
  member => member.id
)

export const normalizeMembers = (members: TeamMember[]) => {
  const membersById: Record<string, TeamMember> = {}
  const memberIds: string[] = []
  for (const member of members) {
    membersById[member.id] = member
    memberIds.push(member.id)
  }
  return { membersById, memberIds }
}
